'use strict';
const angular = require('angular');

/*@ngInject*/
export function StripeService($resource) {
  return $resource('/api/integrations/stripe/:id', {
    id: '@_id'
  },{
    getAccount: {
      method: 'GET',
      url: '/api/integrations/stripe/account/:id'
    },
    getPayments: {
      method: 'GET',
      url: '/api/integrations/stripe/account/:id/payments',
      isArray: true
    },
    getPaymentsByContact: {
      method: 'GET',
      url: '/api/integrations/stripe/account/:id/contact/:email/payments',
      isArray: true
    }
  });
}


export default angular.module('conduu.StripeService', [])
  .factory('StripeService', StripeService)
  .name;



// WEBPACK FOOTER //
// ./client/components/stripe/stripe.service.js